import {
  Computer as ComputerIcon,
  Brightness4 as DarkModeIcon,
  Dashboard as DashboardIcon,
  Brightness7 as LightModeIcon,
  ExitToApp as LogoutIcon,
  Person as PersonIcon,
} from "@mui/icons-material";
import {
  Avatar,
  Box,
  Button,
  Divider,
  AppBar as Header,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { useContext, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import { ThemeContext } from "../../contexts/ThemeContext";

const Navbar = () => {
  const { isAuthenticated, currentUser, logout } = useContext(AuthContext);
  const { themeMode, toggleTheme } = useContext(ThemeContext);
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
    handleClose();
  };

  return (
    <Header
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1, // Ensure navbar stays on top
        background: theme.palette.background.paper,
      }}
    >
      <Toolbar sx={{ px: { xs: 1, sm: 2, md: 3 } }}>
        {/* <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{ mr: 2 }}
        >
          <MenuIcon />
        </IconButton> */}

        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          <RouterLink
            to={
              isAuthenticated
                ? currentUser?.role === "admin"
                  ? "/admin/dashboard"
                  : "/dashboard"
                : "/"
            }
            style={{
              color: "inherit",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            Secfore Portal
          </RouterLink>
        </Typography>

        {/* Theme toggle button */}
        <Tooltip
          title={`Switch to ${themeMode === "dark" ? "light" : "dark"} mode`}
        >
          <IconButton
            onClick={toggleTheme}
            color="inherit"
            aria-label="toggle theme"
            sx={{ mr: { xs: 0.5, sm: 1, md: 1 } }}
          >
            {themeMode === "dark" ? <LightModeIcon /> : <DarkModeIcon />}
          </IconButton>
        </Tooltip>

        {isAuthenticated ? (
          <>
            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <Avatar
                sx={{
                  width: { xs: 28, sm: 30, md: 32 },
                  height: { xs: 28, sm: 30, md: 32 },
                  bgcolor: "secondary.main",
                }}
              >
                {currentUser?.email?.charAt(0)?.toUpperCase()}
              </Avatar>
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {currentUser?.role === "admin" ? (
                <MenuItem
                  component={RouterLink}
                  to="/admin/dashboard"
                  onClick={handleClose}
                >
                  <ListItemIcon>
                    <DashboardIcon fontSize="small" />
                  </ListItemIcon>
                  Admin Dashboard
                </MenuItem>
              ) : (
                <MenuItem
                  component={RouterLink}
                  to="/dashboard"
                  onClick={handleClose}
                >
                  <ListItemIcon>
                    <DashboardIcon fontSize="small" />
                  </ListItemIcon>
                  Dashboard
                </MenuItem>
              )}

              {currentUser?.role === "admin" && (
                <>
                  <MenuItem
                    component={RouterLink}
                    to="/admin/products"
                    onClick={handleClose}
                  >
                    <ListItemIcon>
                      <DashboardIcon fontSize="small" />
                    </ListItemIcon>
                    Manage Products
                  </MenuItem>
                  <MenuItem
                    component={RouterLink}
                    to="/admin/users"
                    onClick={handleClose}
                  >
                    <ListItemIcon>
                      <PersonIcon fontSize="small" />
                    </ListItemIcon>
                    Manage Users
                  </MenuItem>
                  <MenuItem
                    component={RouterLink}
                    to="/admin/hardware-submissions"
                    onClick={handleClose}
                  >
                    <ListItemIcon>
                      <ComputerIcon fontSize="small" />
                    </ListItemIcon>
                    Hardware Submissions
                  </MenuItem>
                  <MenuItem
                    component={RouterLink}
                    to="/admin/resources"
                    onClick={handleClose}
                  >
                    <ListItemIcon>
                      <DashboardIcon fontSize="small" />
                    </ListItemIcon>
                    Manage Resources
                  </MenuItem>
                </>
              )}

              <MenuItem
                component={RouterLink}
                to="/resources"
                onClick={handleClose}
              >
                <ListItemIcon>
                  <DashboardIcon fontSize="small" />
                </ListItemIcon>
                Resources
              </MenuItem>

              {/* Add licenses Management for regular users */}
              {currentUser?.role !== "admin" && (
                <MenuItem
                  component={RouterLink}
                  to="/hardware-management"
                  onClick={handleClose}
                >
                  <ListItemIcon>
                    <ComputerIcon fontSize="small" />
                  </ListItemIcon>
                  licenses Management
                </MenuItem>
              )}

              {/* <MenuItem
                component={RouterLink}
                to="/profile"
                onClick={handleClose}
              >
                <ListItemIcon>
                  <PersonIcon fontSize="small" />
                </ListItemIcon>
                Profile
              </MenuItem> */}

              <Divider />

              <MenuItem onClick={handleLogout}>
                <ListItemIcon>
                  <LogoutIcon fontSize="small" />
                </ListItemIcon>
                Logout
              </MenuItem>
            </Menu>
          </>
        ) : (
          <Box>
            <Button color="inherit" component={RouterLink} to="/login">
              Login
            </Button>
          </Box>
        )}
      </Toolbar>
    </Header>
  );
};

export default Navbar;
